export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/CartIcon.a6310646.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};